// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"33bd9d75","919":"a9efd448"}[chunkId] + ".chunk.js";
};